export default __webpack_public_path__ + "static/media/alied-digital.9746fb69.png";